import React from 'react';

import {useAppDispatch} from 'utils/hooks';

import {hidePopup} from 'store/components/PopupSlice';
import MenuItem from '../menuItem/MenuItem';
import Popup from 'components/popup/Popup';

import './BurgerMenuPopUp.scss';

const BurgerMenuPopUp = () => {
  const dispatch = useAppDispatch();
  
  const hideMenu = () => {
    dispatch(hidePopup('burgerMenu'));
  };

  return (
    <Popup 
      id={'burgerMenu'}
      mode={'slide-left'}
      invisibleHeader={false}
      stylesContent={'menu__popup-content'}
      stylesContainer={'menu__popup-container'}>
      <div className={'menu'}>
        <div
          className={'menu__container'}
          onClick={hideMenu}>
          <ul
            onClick={e => e.stopPropagation()}
            className={'menu__content'}>
            <MenuItem />
          </ul>
        </div>
      </div>
    </Popup>
  );
};

export default BurgerMenuPopUp;
